import ApiService from "../api";

export default class TelemetriaService extends ApiService {

    constructor() {
        super("/api/telemetria");
    }

    listar(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);

        if (values.funcionarioId) params.append('funcionarioId', values.funcionarioId);

        return this.get(`?${params.toString()}`)
    }

    dashboard(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);
        if (values.filialId) params.append('filialId', values.filialId);
        if (values.funcionarioId) params.append('funcionarioId', values.funcionarioId);

        return this.get(`/dashboard?${params.toString()}`)

    }

    listarNaoVinculados(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);
        if (values.filialId) params.append('filialId', values.filialId);

        return this.get(`/nao-vinculados?${params.toString()}`)
    }

    vincularCondutor(motoristaId, funcionarioId) {
        const params = new URLSearchParams();
        params.append('funcionarioId', funcionarioId);

        return this.put(`/nao-vinculados/${motoristaId}/vincular?${params.toString()}`)
    }

    sincronizar(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);


        return this.get(`/sincroniza?${params.toString()}`)
    }

    /* ---------- Gestão das medições (ranking de condutores) ---------- */

    listarMedicoes({ inicio, fim, filialId, funcionarioId }) {
        const params = new URLSearchParams();
        params.append("inicio", inicio);
        params.append("fim", fim);
        if (filialId) params.append("filialId", filialId);
        if (funcionarioId) params.append("funcionarioId", funcionarioId);

        return this.get(`/medicoes?${params.toString()}`);
    }

    criarMedicao(dto) {
        return this.post("/medicoes", dto);
    }

    atualizarMedicao(id, dto) {
        return this.put(`/medicoes/${id}`, dto);
    }

    removerMedicao(id) {
        return this.delete(`/medicoes/${id}`);
    }

    importarMedicoes(arquivo, filialId) {
        const formData = new FormData();
        formData.append("file", arquivo);

        return this.post(`/medicoes/importar?filialId=${filialId}`, formData);
    }

    baixarModelo() {
        return this.fileDownload("/medicoes/modelo");
    }

    // Busca no Trixlog as medições do período (as editadas à mão são preservadas)
    sincronizarTrixlog({ inicio, fim }) {
        const params = new URLSearchParams();
        params.append("inicio", inicio);
        params.append("fim", fim);

        return this.post(`/medicoes/sincronizar-trixlog?${params.toString()}`, null);
    }
}
